module.exports = __webpack_public_path__ + "img/pwax_professorwax.3a2de29.png";